import { render } from "./EditDruhStanoviska.vue?vue&type=template&id=c0a93ac0"
import script from "./EditDruhStanoviska.vue?vue&type=script&lang=js"
export * from "./EditDruhStanoviska.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__